import { Section, SectionSubTitle, Swiper, SwiperSlide, Typography } from 'common/components';
import React from 'react';
import { createElementKey } from 'utils';
import { FLOOR_SCREED_TYPES_LIST } from './floor-screed-types-section-constants';
import { text, typeItem, typeImage } from './floor-screed-types-section-styles';

export const FloorScreedTypesSection = () => (
  <Section>
    <SectionSubTitle margin="m">Подходит для любых напольных покрытий</SectionSubTitle>
    <Typography variant="l" size="body_long" className={text}>
      Полусухая стяжка пола подходит для всех типов напольных покрытий: ламината, линолеума, плитки
      и&nbsp;паркета.
    </Typography>
    <Swiper slidesPerView="auto">
      {FLOOR_SCREED_TYPES_LIST.map((type, index) => (
        <SwiperSlide className={typeItem} key={createElementKey('floor-screed-type', index)}>
          <img
            className={typeImage}
            src={type.imageSrc}
            alt={type.imageAlt}
            title={type.imageAlt}
            width="277"
            height="262"
            loading="lazy"
          />
          <Typography variant="h3">{type.name}</Typography>
        </SwiperSlide>
      ))}
    </Swiper>
  </Section>
);
